<template>
  <div class="imageDiv" v-if="!user">
    <div class="spinner-border" role="status">
      <span class="visually-hidden">Loading...</span>
    </div>
  </div>
  <div class="imageDiv" v-if="user">
    <img v-if="user.photo" :src="user.photo" alt="Profile" class="shadow" />
    <br /><br />
    <h1 class="about">
      <b>{{ user.name }}</b>
    </h1>
    <p class="about">
      <b>{{ title }}</b>
    </p>
    <p class="about">
      {{ user.bio }}
    </p>
    <a :href="user.github_url" target="_blank"
      ><i class="fab fa-github icon"></i
    ></a>
    <a :href="user.facebook_url" target="_blank"
      ><i class="fab fa-facebook icon"></i
    ></a>
    <a :href="user.linkedin_url" target="_blank"
      ><i class="fab fa-linkedin icon"></i
    ></a>
    <a :href="'mailto:' + user.email_url"
      ><i class="fas fa-envelope icon"></i
    ></a>
    <a :href="user.stackoverflow_url" target="_blank"
      ><i class="fab fa-stack-overflow icon"></i
    ></a>
    <a :href="user.twiter_url" target="_blank"
      ><i class="fab fa-twitter icon"></i
    ></a>
  </div>
</template>

<script>
export default {
  name: "InfoCard",
  props: ["user"],
};
</script>


<style scoped>
.icon {
  width: 2rem;
  height: 2rem;
  margin-left: 1rem;
  margin-right: 1rem;
  margin-top: 1rem;
  color: black;
}

.icon:hover {
  color: blue;
}

img {
  border-radius: 50%;
  width: 20rem;
  height: 20rem;
  object-fit: cover;
  border: 5px solid black;
}
.imageDiv {
  text-align: center;
  margin-top: 5%;
}
.about {
  font-family: "Courier New", Courier, monospace;
}
</style>